import { z } from 'zod'

import { occasionType } from './product.js'

/**
 * 조직 즐겨찾기 — 셀프 큐레이션 (BIZ-83).
 *
 * 전역 상품 목록에서 기업 관리자가 별표(star)로 주문서에 쓸 상품을 스스로 고른다.
 * 데이터는 기존 `company_product` 재사용 — 별표=행 추가, 해제=삭제. 큐레이션이 하나라도
 * 있으면 주문 카탈로그가 그 목록으로 좁아진다(BIZ-82 폴백과 연동).
 *
 * 운영자가 협의단가·표시명 등을 걸어둔 행(locked)은 셀프 해제 불가 — 협의 정보 보호.
 */
export const orgCatalogItem = z.object({
  productId: z.number().int(),
  /** custom_name(운영자 지정)이 있으면 그것, 없으면 상품명. */
  name: z.string(),
  category: z.string(),
  occasionType,
  imageUrl: z.string().nullable(),
  summary: z.string().nullable(),
  /** 적용가 — 협의단가가 있으면 그것, 없으면 기본가. */
  price: z.number().int(),
  /** 이 회사가 별표를 켰는지(주문서 노출 여부). */
  starred: z.boolean(),
  /** 기본상품(주문서 프리셀렉트). 기업당 하나. */
  isDefault: z.boolean(),
  /** 운영자 오버라이드(협의단가·표시명 등)가 걸린 행 — 셀프 해제 불가. */
  locked: z.boolean(),
})
export type OrgCatalogItem = z.infer<typeof orgCatalogItem>

export const orgCatalogListResponse = z.object({
  items: z.array(orgCatalogItem),
  /** 별표가 하나라도 있는지 = 주문서가 큐레이션 목록으로 좁혀졌는지(절벽 안내용). */
  curated: z.boolean(),
})
export type OrgCatalogListResponse = z.infer<typeof orgCatalogListResponse>

/**
 * 별표 토글·기본지정. starred=false는 해제(운영자 잠금 행이면 거부). starred=true는 연결,
 * isDefault=true면 기본상품으로 지정(기존 기본은 자동 해제).
 */
export const updateOrgCatalogRequest = z.object({
  starred: z.boolean(),
  isDefault: z.boolean().optional(),
})
export type UpdateOrgCatalogRequest = z.infer<typeof updateOrgCatalogRequest>
